export enum InvoiceType {
  TOPUP = 'TOPUP',
  PLAN = 'PLAN',
}
